// extracted by mini-css-extract-plugin
module.exports = {"app":"MainLayout_app__RcuhX","mainContent":"MainLayout_mainContent__uUhjw"};